import {
  updateUserJournals,
  fetchJournals,
  fetchUserJournals,
  removeUserJournals,
  createUserJournals
} from '../api/journals';

import {
  GET_USER_JOURNALS,
  PATCH_USER_JOURNALS,
  CREATE_USER_JOURNALS,
  DELETE_USER_JOURNALS
} from '../constants/journals';

export const getUserJournals = () => async (dispatch) => {
  const userJournals = await fetchUserJournals();
  let journals = (await fetchJournals()) || [];
  journals = journals.filter((journal) => journal.display);

  journals = journals.map((journal) => {
    const userJournal = userJournals.find(
      (item) => item.journal === journal.id
    );
    if (userJournal) {
      journal.data = userJournal;
    }
    return journal;
  });
  dispatch({
    type: GET_USER_JOURNALS,
    payload: journals
  });
};

export const patchUserJournals = (data) => async (dispatch) => {
  await updateUserJournals(data);
  dispatch({
    type: PATCH_USER_JOURNALS,
    payload: data
  });
};

export const deleteUserJournals = (id) => async (dispatch) => {
  await removeUserJournals(id);
  dispatch({
    type: DELETE_USER_JOURNALS,
    payload: id
  });
};

export const postUserJournals = (data) => async (dispatch) => {
  await createUserJournals(data);
  dispatch({
    type: CREATE_USER_JOURNALS,
    payload: data
  });
};
